export const getScriptBlobUrl = (url) => {
	return fetch(url)
		.then((data) => data.text())
		.then((textData) => {
			const blob = new Blob([textData], {
				type: 'application/javascript',
			});
			return URL.createObjectURL(blob);
		});
};
